import { ProductClient as BaseProductClient } from '@jbhi-fi/apis/src/algolia/ProductClient';
import { baseConfig } from '../../config/algolia';
import { serviceHelper } from '../../config/service-helper';

export class ProductClient extends BaseProductClient {
  constructor(overrides: Partial<ConstructorParameters<typeof BaseProductClient>[0]> = {}) {
    const recommendationsEndpoint = serviceHelper.googleRecommendationEndpoint;
    const googleSearchEndpoint = serviceHelper.googleSearchEndpoint;

    const { shouldExcludeMarketplaceProductsFromSuggestions } = window.Jbhifi?.marketplaceSettings ?? {};
    const shouldUseBrowseApi = window.Jbhifi?.productFetchingSettings?.skuQuerySource === 'browse';
    const batchedQueriesWaitTimeMs = window.Jbhifi?.productFetchingSettings?.batchedQueriesWaitTimeMs;

    super({
      shopifyProductsGqlUrl: serviceHelper.shopifyProductsGraphQlPath ?? '',
      shopifyProductsGqlToken: serviceHelper.shopifyProductsGraphQlToken ?? '',
      algoliaSearchIndex: baseConfig.product_families_index ?? '',
      algoliaSearchApiKey: baseConfig.product_families_api_key ?? '',
      algoliaAppId: baseConfig.app_id ?? '',
      recommendationsEndpoint,
      googleSearchEndpoint,
      googleSearchApiKey: serviceHelper.googleSearchApiKey ?? '',
      shouldExcludeMarketplaceProductsFromSuggestions,
      shouldUseBrowseApi,
      batchedQueriesWaitTimeMs,
      ...overrides,
    });
  }
}

export class ProductClientNonFamily extends ProductClient {
  constructor(overrides: Partial<ConstructorParameters<typeof BaseProductClient>[0]> = {}) {
    super({
      algoliaSearchIndex: baseConfig.index_products ?? '',
      ...overrides,
    });
  }
}

export const productClient = new ProductClient();
export const productClientNonFamily = new ProductClientNonFamily();
